import React from "react";
import Meta from "./../components/Meta";
import HeroSection3 from "./../components/HeroSection3";
import ContentCardsSection from "./../components/ContentCardsSection";
import FeaturesSection2 from "./../components/FeaturesSection2";
import FeaturesSection3 from "./../components/FeaturesSection3";
import Section from "../components/Section";
import Section2 from "../components/Section2";
import Section3 from "../components/Section3";
import ClientsSection2 from "../components/ClientsSection2";
import ClientsSection3 from "../components/ClientsSection3";
import ClientsSection4 from "../components/ClientsSection4";
import NewsletterSection from "../components/NewsletterSection";
import { useMediaQuery } from 'react-responsive';

function DeveloperPage(props) {
  const isSmallMobile = useMediaQuery({ query: '(max-width: 440px)' });  
  const widgetSize = isSmallMobile ? '245px' : '260px'

  return (
    <>
      <br>
      </br>
      <Meta title="Developer Portal" />
      <HeroSection3
        color="navy"
        size="medium"
        backgroundImage="/halftone-1696542371.svg"
        backgroundImageOpacity={1}
        title="Developer Portal"
        subtitle="PDS supports a diverse and growing ecosystem of customer-developed software projects using our Property Rights Protocol and licensing exchange. We will work with you to determine the best approach for building an application to leverage your organization’s data/IP and turn them into trackable and monetizable assets."
        buttonText="Get on board"
        buttonColor="primary"
        buttonInverted={false}
        buttonPath="/contact"
      />
      <Section2
        color="secondary"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity=""
        title="Digital Property Rights Protocol"
        subtitle="Learn more about PDS technology and how to get started with our API."
        className="has-text-centered"
      />
      <FeaturesSection2
        color="white"
        size="medium"
        backgroundImage="/halftone-1696542371.svg"
        backgroundImageOpacity={1}
        image="rocket.svg"
      />
      <Section2
        color="secondary"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity=""
        title=""
        subtitle="Built by a team of seasoned enterprise systems developers with strong cryptography/blockchain expertise, the PDS API is a powerful tool for building new decentralized applications and integrating existing apps with PDS."
        image=""
        className="has-text-centered"
      />
      <FeaturesSection3
        color="white"
        size="medium"
        backgroundImage="/halftone-1696560535.svg"
        backgroundImageOpacity={1}
        title="Resources"
        subtitle="Use these resources to get started building, integrating and deploying applications with PDS."
      />
      <Section3
        color="secondary"
        size="small"
        backgroundImage=""
        backgroundImageOpacity=""
        title="PDS Platform Overview"
        subtitle="PDS architecture allows for plug-and-play integration across customer technology stacks without the need for complicated migrations and blockchain programming."
        image="pds_platform_overview.svg"
        className="has-text-centered"
      />
      <ContentCardsSection
        color="white"
        size="medium"
        backgroundImage="/halftone-1696542371.svg"
        backgroundImageOpacity={1}
        title="Platform features"
        subtitle=""
      />
      <ClientsSection3 
        color="secondary"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity=""
        title="Cloud Storage Providers"
        subtitle="Bind a PDS vault (our API/license access gatekeeping service) to a new or existing cloud storage instance and start uploading/registering files as data assets on the blockchain. You can bind a PDS Vault to any storage system (in the cloud or on premises), but we have pre-built integrations with the following cloud providers:"
      />
      <ClientsSection4 
        color="secondary"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity=""
        title="Technology we like"
        subtitle="Developers have built PDS apps using a variety of software languages, frameworks, libraries, and tools, including:"
      />
      <Section
        color="secondary"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity=""
        title="Get in touch with us!"
        subtitle="We can guide you in best practices for building dApps on the PDS platform."
        className="has-text-centered"
      />
      <iframe
      src="https://discordapp.com/widget?id=751490770766397502&theme=light"
      style={{ margin: "20px auto", display: "block", border: "solid black 2px", borderRadius: "10px"}}
      title="PDS Discord"
      height="500"
      width={widgetSize}
      padding="10px"
      allowtransparency="true"
      sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
      ></iframe> 
      <ClientsSection2
        color="secondary"
        size="normal"
        backgroundImage=""
        backgroundImageOpacity=""
        title=""
        image=""
        subtitle="Or, find us on" 
      />
      <NewsletterSection
        color="light"
        size="medium"
        backgroundImage=""
        backgroundImageOpacity={1}
        title="Stay informed!"
        subtitle="Sign up to receive updates about PDS developer news and releases."
        buttonText="Subscribe"
        buttonColor="primary"
        buttonInverted={false}
        inputPlaceholder="Enter your email"
        subscribedMessage="You are now subscribed!"
      />
    </>
  );
}

export default DeveloperPage;
